import React, { useState } from "react";
import styles from "./hoverTile.module.scss";
import { AccountCircleOutlined } from "@mui/icons-material";

const HoverTile = ({ hoverData }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className={styles.container}>
      {hoverData?.map((item, index) => (
        <div className={styles.wrapper} key={index}>
          <div className={styles.left}>
            <AccountCircleOutlined fontSize="30" />
          </div>
          <div
            className={styles.right}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className={styles.rightTop}>{item?.question}</div>
            <div
              className={`${styles.rightBottom} ${
                hoveredIndex === index ? styles.visible : ""
              }`}
            >
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HoverTile;
